export default __webpack_public_path__ + "static/media/logo.dcb90953.png";